/**
 * parts.js  — parts, categories, and AI category generation
 */
import api from './auth';

/* ── Categories ────────────────────────────────────────────────────── */

/** Returns flat category rows: { categoryId, category, subCategoryId, sub_category, … } */
export async function getCategories(vehicleId) {
  const { data } = await api.get(`/vehicles/${vehicleId}/categories`);
  return data; // { success, data: [ flat rows ] }
}

/** Triggers Claude to generate + save the category hierarchy for this vehicle */
export async function generateCategories(vehicleId) {
  const { data } = await api.post(`/vehicles/${vehicleId}/ai-categories`);
  return data; // { success, data: { vehicleId, vehicle, summary, tokens, hierarchy } }
}

/** Returns category tree with part counts per node */
export async function getCategoryTree(vehicleId) {
  const { data } = await api.get('/parts/category-tree', {
    params: { vehicleId },
  });
  return data;
}

/* ── AI Parts generation ───────────────────────────────────────────── */

/**
 * Generate parts for the whole vehicle (original broad call).
 * payload: { year, make, model, variant, engine }
 */
export async function generateAiParts(vehicleId, payload) {
  const { data } = await api.post(`/vehicles/${vehicleId}/ai-parts`, payload);
  return data;
}

/**
 * Generate parts scoped to a single sub-system.
 * payload: { year, make, model, variant, engine, category, sub_category }
 */
export async function generateSubSystemParts(vehicleId, payload) {
  const { data } = await api.post(`/vehicles/${vehicleId}/ai-parts`, payload);
  return data;
}

/* ── Parts list ────────────────────────────────────────────────────── */

/**
 * List parts for a vehicle, optionally filtered by subCategoryId.
 * GET /parts?vehicleId=X&categoryId=Y
 */
export async function listParts(vehicleId, categoryId = null) {
  const params = { vehicleId };
  if (categoryId) params.categoryId = categoryId;
  const { data } = await api.get('/parts', { params });
  return data; // { success, data: [ part rows ] }
}

/** Get a single part */
export async function getPart(partId) {
  const { data } = await api.get(`/parts/${partId}`);
  return data;
}
